var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22q-4.187 0-7.094-2.906T2 12t2.906-7.094T12 2q2.157 0 4.125.89A9.5 9.5 0 0 1 19.5 5.439V3.25q0-.531.36-.89.359-.36.89-.36t.89.36.36.89V9.5q0 .531-.36.89-.359.36-.89.36H14.5a1.2 1.2 0 0 1-.89-.36 1.2 1.2 0 0 1-.36-.89q0-.531.36-.89.359-.36.89-.36h4a7.3 7.3 0 0 0-2.734-2.75A7.4 7.4 0 0 0 12 4.5q-3.125 0-5.312 2.188Q4.5 8.875 4.5 12t2.188 5.313T12 19.5q2.126 0 3.89-1.078a7.44 7.44 0 0 0 2.735-2.89q.25-.438.703-.61t.922-.016q.5.156.719.656t-.032.938q-1.28 2.5-3.656 4Q14.907 22 12 22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshFill);
export default __webpack_public_path__ + "static/media/refresh_fill.238795c747c4c357a56ab0ca80964985.svg";
export { ForwardRef as ReactComponent };